export default "__VITE_ASSET__a55Ifzq6__"